import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";


export function tutorsRatings(rating: object): Promise<ApiResponse> {
  return Axios.post("/v1/tutors/ratings", rating);
}
